import { render, staticRenderFns } from "./document.vue?vue&type=template&id=7232f694"
import script from "./document.vue?vue&type=script&lang=js"
export * from "./document.vue?vue&type=script&lang=js"
import style0 from "./document.vue?vue&type=style&index=0&id=7232f694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports